import { cardanoContent } from "./cardanoContent";
import { ethereumContent } from "./ethereumContent";

const content = {
  CARDANO: cardanoContent,
  ETHEREUM: ethereumContent,
};

export default content;
